import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../../private/shared/modules/shared.module';
import { ModuleSharedModule } from '../../modules/module-shared.module';
import { FavoritosInfoModalModule } from '../favoritos-info-modal/favoritos-info-modal.module';
import { InfoSheetModalPage } from './info-sheet-modal.page';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        SharedModule,
        TranslateModule,
        ModuleSharedModule,
        FavoritosInfoModalModule,
    ],
    declarations: [
        InfoSheetModalPage
    ]
})
export class InfoSheetModalPageModule { }
